import {
  AspectRatio,
  Button,
  Image,
  SimpleGrid,
  Tag,
} from '@cardboard-ui/react';
import React from 'react';
import defaultImage1 from 'assets/images/portrait-colors.jpg';
import defaultImage2 from 'assets/images/landscape-tiles.jpg';
import defaultImage3 from 'assets/images/portrait-wall.jpg';
import defaultImage4 from 'assets/images/portrait-papers.jpg';
import { t } from '@lingui/macro';
import { useSpaceShortcutDimensions } from 'components/SpaceShortcutCard/SpaceShortcutCard';

interface GalleryImageProps {
  defaultImage?: string;
  onPickImage: (source: string) => void;
}

// defaultImage4 is first because it is the default fallback image, so it makes sense to show this one first
const galleryImages = [
  defaultImage4,
  defaultImage1,
  defaultImage2,
  defaultImage3,
];

function moveDefaultImageFirstWithoutDuplication(
  defaultImage: string | undefined,
  defaultImages: string[],
) {
  if (defaultImage) {
    const shouldDeduplicateFromGallery = galleryImages.includes(defaultImage);

    if (shouldDeduplicateFromGallery) {
      return [
        defaultImage,
        ...defaultImages.filter((value) => value !== defaultImage),
      ];
    } else {
      return [defaultImage, ...defaultImages];
    }
  }
  return [...defaultImages];
}

export function DefaultImagesGallery({
  defaultImage,
  onPickImage,
}: GalleryImageProps) {
  const images = moveDefaultImageFirstWithoutDuplication(
    defaultImage,
    galleryImages,
  );
  const dimensions = useSpaceShortcutDimensions();
  const ratio = parseInt(dimensions.width) / parseInt(dimensions.height);

  return (
    <SimpleGrid spacing={2} columns={3} autoColumns="1fr">
      {images.map((imageSrc) => {
        return (
          <AspectRatio key={imageSrc} ratio={ratio}>
            <Button
              variant="unstyled"
              onClick={() => onPickImage(imageSrc)}
              _focus={{
                outlineWidth: '2px',
                outlineColor: 'blue.500',
              }}
            >
              <Image
                w="100%"
                h="100%"
                src={imageSrc}
                objectFit="cover"
                alt=""
              />
              {defaultImage === imageSrc ? (
                <Tag
                  pos="absolute"
                  top={1}
                  right={1}
                  bg="blue.500"
                  color="white"
                >
                  {t`Default`}
                </Tag>
              ) : null}
            </Button>
          </AspectRatio>
        );
      })}
    </SimpleGrid>
  );
}
